module.exports = __webpack_public_path__ + "media/images/front/programs/icon-checkbox-on-78ecae988b4ef0628680957141c42fb0.svg";